import React from 'react';
import { SkeletonAnimation } from 'app/types/SkeletonAnimation';
import MediaElementSkeleton from 'app/components/mediaModule/content/MediaElementSkeleton';
import { View } from 'app/components/mediaModule/content/contentStyles';
import { StepperPlaceholder } from 'app/components/styles/swipeableViews/StepperPlaceholder';
export default function LoadingSkeleton(_ref) {
  let {
    animation = SkeletonAnimation.Pulse
  } = _ref;
  const children = Array.from({
    length: 4
  }, (_value, index) => /*#__PURE__*/React.createElement(MediaElementSkeleton, {
    key: "media-element-skeleton-".concat(index),
    animation: animation
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    "data-sentry-element": "View",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, children), /*#__PURE__*/React.createElement(StepperPlaceholder, {
    "data-sentry-element": "StepperPlaceholder",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }));
}